import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderContainer = styled.div`
  font-family: "Pretendard", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5vh 5%;
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const Title = styled.h3`
  color: #1FBC70;
  font-size: 20px;
  margin: 0;
  font-family: 'GmarketSans', sans-serif;
  font-weight: 700;
`;

export const IconGroup = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

export const IconLink = styled(Link)`
  font-size: 1.5em;
  text-decoration: none;
  position: relative;

  img {
    width: 24px;
    height: 24px;
  }
`;

export const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background: #FC324A;
  color: white;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;
